import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { ROUTES } from "../../lib/routes";
import { DEPARTMENT_SHORT, getAlumnus } from "../../lib/alumni";
import { ALUMNI_GUEST_HOUSE } from "../../lib/alumniEvents";

/**
 * Three of the Association's own distinguished-alumni entries, across three
 * departments and three routes out of the institute — running a company,
 * founding one, and research.
 *
 * Resolved by slug so the roster stays the single source: editing a name or role
 * in alumni.ts changes it here too, and a slug that stops existing fails the
 * build rather than rendering an empty card.
 */
const FEATURED = ["bp-ramesh", "vivek-thontadarya", "alok-kumar-bharati"].map((s) => getAlumnus(s)!);

/**
 * The lead feature card's spotlight — one alumnus, changed by hand as the
 * Association surfaces someone worth leading with. Currently Srivatsa Katta
 * (CS&E), CTO at Rapido.
 */
const SPOTLIGHT = getAlumnus("srivatsa-katta")!;

export function Alumni() {
  return (
    <section className="section alumni-feature-section">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="kicker">From our alumni</div>
            <h2>Decades of stories. One institution.</h2>
          </div>
          <Link className="btn-link" to={ROUTES.alumni}>
            Alumni network <span className="arr">→</span>
          </Link>
        </div>

        <div className="alumni-feature reveal">
          <div className="alumni-feature-bg" aria-hidden="true">
            <Figure
              media={ALUMNI_GUEST_HOUSE.hero}
              fallbackLabel="ALUMNI GUEST HOUSE · BIET"
              aspect="auto"
              sizes="100vw"
              style={{ position: "absolute", inset: 0 }}
            />
          </div>
          <Figure
            media={SPOTLIGHT.photo}
            fallbackLabel={SPOTLIGHT.name}
            aspect="4/3"
            className="alumni-spotlight-photo"
            sizes="240px"
          />
          <div className="alumni-feature-body">
            <h3>From BIET to CTO of Rapido.</h3>
            <p>{SPOTLIGHT.story?.[0] ?? SPOTLIGHT.note}</p>
            <Link className="btn-link" to={`${ROUTES.alumni}/${SPOTLIGHT.slug}`}>
              Read {SPOTLIGHT.name.split(" ")[0]}'s story <span className="arr">→</span>
            </Link>
          </div>
        </div>

        <div className="alumni-quotes">
          {FEATURED.map((a) => (
            <Link key={a.slug} to={`${ROUTES.alumni}/${a.slug}`} className="alumni-quote reveal">
              <div className="alumni-quote-dept">{DEPARTMENT_SHORT[a.department] ?? a.department}</div>
              <p>{a.role}</p>
              {a.note && <div className="alumni-quote-note">{a.note}</div>}
              <div className="alumni-quote-meta">
                <Figure
                  media={a.photo}
                  fallbackLabel={a.name}
                  aspect="1/1"
                  className="alumni-avatar"
                  sizes="56px"
                />
                <div>
                  <div className="alumni-name">{a.name}</div>
                  {(a.basedIn || a.year) && (
                    <div className="alumni-role">{a.basedIn ?? `Class of ${a.year}`}</div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
